// Components==============
import indexActivities from 'actions/activity/index';
import Dropdown from 'components/UI/Dropdown/Dropdown';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { useContext, useEffect, useState } from 'react';
import { FilterType, TranslateType } from 'typings';
import { FilterContext } from '../../FilterMenu';
// =========================

export default function ActivityDropdown({
  initialText,
  id,
}: {
  initialText: TranslateType;
  id: number;
}) {
  const { setFilterValues, triggerReset } = useContext(FilterContext);
  const dispatch = useReduxAction();

  const [selected, setSelected] = useState<string[]>([]);

  useEffect(() => {
    dispatch(indexActivities());
  }, []);

  const activities = useRedux((state) =>
    state.activity?.entities.allIds
      .map((skillId) => state.activity?.entities.byId[skillId])
      .filter((a) => a?.type === 'regular')
  );

  const options = activities?.map((activity) =>
    activity?.name ? activity?.name : ''
  );

  useEffect(() => setSelected([]), [triggerReset]);

  useEffect(() => {
    const newValue = activities
      ?.filter((activity) =>
        activity?.name ? selected.includes(activity?.name) : false
      )
      .map((activity) => activity?.id);

    setFilterValues(
      (prev) =>
        prev.map((val) =>
          val.id === id ? { ...val, value: newValue } : val
        ) as FilterType[]
    );
  }, [selected]);

  return (
    <Dropdown
      initialText={initialText}
      selectedItems={selected}
      setSelectedItems={setSelected}
      initialOptions={options || []}
    />
  );
}
